import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../../utils/withDefaults';
export const Root = styled('section')({
  maxWidth: 552,
  margin: 'auto'
});
const TitleRoot = styled(Typography)(({
  theme
}) => ({
  marginTop: theme.spacing(3),
  textAlign: 'center',
  color: theme.palette.grey[900]
}));
export const Title = withDefaults(TitleRoot, {
  variant: 'Lato H4 Bold'
});